"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineConfirmButton =
/*#__PURE__*/
function (_Component) {
  _inherits(InlineConfirmButton, _Component);

  function InlineConfirmButton(props) {
    var _this;

    _classCallCheck(this, InlineConfirmButton);

    _this = _possibleConstructorReturn(this, (InlineConfirmButton.__proto__ || Object.getPrototypeOf(InlineConfirmButton)).call(this, props));
    Object.defineProperty(_this, "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (!_this.props.disabled) {
          var textValues = _this.props.textValues;
          var stepIndex = textValues.indexOf(_this.state.buttonText);

          if (stepIndex < textValues.length - 2) {
            var resetTimer = setTimeout(function () {
              this.setState({
                buttonText: textValues[stepIndex],
                className: this.props.className,
                isPrompting: false
              });
            }.bind(_this), _this.props.timeOut);

            _this.setState({
              resetTimer: resetTimer,
              buttonText: textValues[stepIndex + 1],
              className: _this.props.className ? "".concat(_this.props.className, " btn-danger") : _this.props.className,
              isPrompting: true
            });
          } else if (stepIndex === textValues.length - 2) {
            if (_this.state.resetTimer) {
              clearTimeout(_this.state.resetTimer);
            }

            _this.setState({
              resetTimer: null,
              buttonText: textValues[textValues.length - 1],
              className: "".concat(_this.props.className ? _this.props.className + " " : null, "active disabled"),
              isPrompting: false
            });

            _this.props.onClick(event);
          }
        }
      }
    });
    _this.state = {
      resetTimer: null,
      buttonText: _this.props.textValues[0],
      className: _this.props.className,
      isPrompting: false,
      isTimedOut: false
    };
    return _this;
  }

  _createClass(InlineConfirmButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isPrompting && !this.state.isPrompting) {
        this.setState({
          isTimedOut: true
        });
      }

      if (!prevState.isPrompting && this.state.isPrompting) {
        this.setState({
          isTimedOut: false
        });
      }

      if (prevProps.isExecuting && !this.props.isExecuting) {
        this.setState({
          resetTimer: null,
          buttonText: prevProps.textValues ? prevProps.textValues[0] : null,
          className: prevProps.className,
          isPrompting: false
        });
      }

      if (!prevProps.isExecuting && this.props.isExecuting) {
        this.setState({
          resetTimer: null,
          buttonText: prevProps.textValues ? prevProps.textValues[prevProps.textValues.length - 1] : null,
          className: "".concat(prevProps.className ? prevProps.className + " " : null, "active disabled"),
          isPrompting: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var duration = this.state.isTimedOut ? 0 : this.props.timeOut / 1000;
      var transition = "".concat(duration, "s width linear");
      var progressStyles = {
        borderTop: "2px solid",
        marginTop: "-2px",
        width: this.state.isPrompting ? "0" : "100%",
        transition: transition,
        opacity: this.state.isPrompting ? 1 : 0
      };
      var progressBar = this.props.showTimer ? _react.default.createElement("div", {
        style: progressStyles
      }) : null;
      return _react.default.createElement("button", {
        disabled: this.props.disabled,
        type: "button",
        className: this.state.className,
        onClick: this.handleClick
      }, this.props.children, _react.default.createElement("span", null, this.state.buttonText), progressBar);
    }
  }]);

  return InlineConfirmButton;
}(_react.Component);

exports.default = InlineConfirmButton;
InlineConfirmButton.propTypes = {
  showTimer: _propTypes.PropTypes.bool,
  timeOut: _propTypes.PropTypes.number,
  disabled: _propTypes.PropTypes.bool,
  onClick: _propTypes.PropTypes.func.isRequired,
  isExecuting: _propTypes.PropTypes.bool.isRequired,
  textValues: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.string).isRequired
};
InlineConfirmButton.defaultProps = {
  showTimer: false,
  timeOut: 3000
};
